import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-gray-900 dark:bg-gray-950 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">
              <a
                href="https://tecitbettersolution.com.br/"
                className="hover:text-blue-200"
                target="_blank"
                rel="noopener noreferrer"
              >
                TEC-IT SUPORTE
              </a>
            </h3>
            <p className="text-gray-300 text-sm">
              {t.footer.companyDesc}
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">{t.footer.quickAccess}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/chamados" className="text-gray-300 hover:text-white">{t.footer.myTickets}</Link></li>
              <li><Link to="/novo-chamado" className="text-gray-300 hover:text-white">{t.footer.openTicket}</Link></li>
              <li><Link to="/sla" className="text-gray-300 hover:text-white">{t.footer.slaLevels}</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">{t.footer.support}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/faq" className="text-gray-300 hover:text-white">FAQ</Link></li>
              <li><Link to="/politica-de-servico" className="text-gray-300 hover:text-white">{t.footer.servicePolicy}</Link></li>
              <li><a href="mailto:suporte@tecitbettersolution.com.br" className="text-gray-300 hover:text-white">{t.footer.contact}</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">{t.footer.contact}</h4>
            <div className="text-sm text-gray-300 space-y-2">
              <p>
                📧{" "}
                <a
                  href="mailto:suporte@tecitbettersolution.com.br"
                  className="text-gray-300 hover:text-white underline underline-offset-2"
                >
                  suporte@tecitbettersolution.com.br
                </a>
              </p>
              <p>📞 (11) 98546-4552</p>
              <p>🕒 {t.footer.available24}</p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-300">
          <p>
            &copy; 2024{" "}
            <a
              href="https://tecitbettersolution.com.br/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white underline underline-offset-2"
            >
              TEC-IT
            </a>. {t.footer.rightsReserved}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
